
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/events/calendar/competition_registration/view.css.ts.vanilla.css\",\"source\":\"LnZvcnF1ZzAgewogIG1pbi13aWR0aDogNTAlOwp9Ci52b3JxdWcxIHsKICBtaW4td2lkdGg6IDEyMHB4Owp9Ci52b3JxdWcyIHsKICB3aWR0aDogMzAwcHg7Cn0KLnZvcnF1ZzMgewogIGZsZXg6IDEgMCAzMDBweDsKICBtYXgtd2lkdGg6IDYwMHB4Owp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/events/calendar/competition_registration/view.css.ts.vanilla.css\",\"source\":\"LnZvcnF1ZzAgewogIG1pbi13aWR0aDogNTAlOwp9Ci52b3JxdWcxIHsKICBtaW4td2lkdGg6IDEyMHB4Owp9Ci52b3JxdWcyIHsKICB3aWR0aDogMzAwcHg7Cn0KLnZvcnF1ZzMgewogIGZsZXg6IDEgMCAzMDBweDsKICBtYXgtd2lkdGg6IDYwMHB4Owp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
